module.exports = __webpack_public_path__ + "media/newstyle/images/icon-feature-detail-e050afc7e27539ab3c8eec3aebed71e9.svg";